module.exports = __webpack_public_path__ + "media/images/application/template/icon--link-external-66453e8af466dfc3e01d6c135f380f35.svg";